import React from 'react'
import "./NotFound.css"
import NoFound from "./nofound.png"

function Notfound(props) {
  return (
    
    <div style={{textAlign: "center", width: "100%"}} className="notfound">
      <div style={props.theme}>
        <img src={NoFound} alt="" width='400' className='logo-err' />
      </div>
        <h1 style={props.theme}>No Results Found</h1>
    </div>
  )
}

export default Notfound